// extracted by mini-css-extract-plugin
export default {"abmAgentesContainer":"Agentes_abmAgentesContainer__exgI+","agentesEditForm":"Agentes_agentesEditForm__iqkzF"};